import React, { Component } from 'react';
import { connect } from "react-redux";
import moment from "moment";

import Stars from '../../../../Common/Stars';
import { DivisionIcon, VCIcon } from '../../../../Common/Buttons/TypeIcons';
import { ActivityActive, ActivityInactive, Ellipsis, VehicleIncoming, RetireListView, EditDefault, VehicleReminderAdd, VehicleRetire } from '../../../../Common/Buttons/Icons';
import VehicleCell from '../VehicleCell';

class VehiclesListRow extends Component {
    constructor(props) {
        super(props);

        this.editVehicle = this.editVehicle.bind(this);
        this.addReminder = this.addReminder.bind(this);
        this.retireVehicle = this.retireVehicle.bind(this);
        this.toggleActionDropdown = this.toggleActionDropdown.bind(this);

        this.state = {
            action_dropdown: false
        };
    }

    setRowClass(vehicle) {
        if (vehicle.status === 'active' || (vehicle.latestBooking && moment(vehicle.latestBooking?.scheduledReturnedAt).isSameOrAfter(moment().subtract(90, 'days')))) {
            if (vehicle.latestBooking && moment(vehicle.latestBooking?.scheduledReturnedAt).isSameOrAfter(moment().subtract(90, 'days'))) {
                return 'row-active'
            } else if (moment(vehicle.availableAt, "YYYY-MM-DD").startOf('day').isBefore(moment().subtract(90, 'days').startOf('day'))) {
                return 'row-inactive'
            }
        }

        return 'row-grey'
    }

    setVehicleLocationIcon(vehicle) {
        if (vehicle.status === 'active') {
            return ActivityActive();
        }

        if (vehicle.status === 'retired') {
            return RetireListView();
        }

        if (vehicle.status === 'incoming') {
            return VehicleIncoming();
        }

        /*
            if (vehicle.Active === -1) {
                return(
                RetireListView()
                )
            } else if (vehicle.status === 'Vehicle Center') {
                return(
                    VCDefault()
                )
            } else if (vehicle.status === 'Service') {
                return(
                    ServiceDefault()
                )
            } else if (vehicle.status === 'Incoming') {
                return(
                    VehicleIncoming()
                )
            } else if (vehicle.status === 'On Booking') {
                return(
                    CalendarUncoloured()
                )
            }
        */
    }

    setBookingActivityIcon(vehicle) {
        if (vehicle.status === 'active' || moment(vehicle.latestBooking?.scheduledReturnedAt).isValid()) {
            if (vehicle.latestBooking && moment(vehicle.latestBooking?.scheduledReturnedAt).isSameOrAfter(moment().subtract(90, 'days'))) {
                return ActivityActive();
            } else if (moment(vehicle.availableAt, "YYYY-MM-DD").startOf('day').isBefore(moment().subtract(90, 'days').startOf('day'))) {
                return ActivityInactive();
            }
        }

        return <img src = "images/png-icons/dash-grey.png"/>
    }

    editVehicle(vehicle) {
        this.toggleActionDropdown("action-dropdown-" + id)

        const { path } = this.props.match;
        const { V_ID, id } = vehicle;

        this.props.history.push(`${path}/vehicle/${V_ID}/Edit/${id}`);
    }

    addReminder(id) {
        this.toggleActionDropdown("action-dropdown-" + id);

        const { path } = this.props.match;
        this.props.history.push(`${path}/vehiclereminder/${id}`);
    }

    retireVehicle(id) {
        this.toggleActionDropdown("action-dropdown-" + id);

        const { path } = this.props.match;
        this.props.history.push(`${path}/retire/${id}`);
    }

    toggleActionDropdown(id) {
       this.setState({
           action_dropdown: !this.state.action_dropdown
       })
    }

    render() {
        return (
            <tr className={this.setRowClass(this.props.vehicle)}>
                <td className = "w-180">
                    <VehicleCell history={this.props.history} match={this.props.match} location={this.props.location} vehicle={this.props.vehicle} key={this.props.vehicle.V_ID} showType={false} noTooltip />
                </td>
                <td className = "single-img-cell align-center">
                    {this.setVehicleLocationIcon(this.props.vehicle)}
                </td>
                <td className = "single-img-cell align-center">
                    {this.setBookingActivityIcon(this.props.vehicle)}
                </td>
                <td className = "multi-img-cell px-26 align-center">
                    {DivisionIcon(this.props.userSession?.user?.profile_access?.active_sh_vmh_access.find((item) => {return item.SH_ID == this.props.vehicle.SH_ID})?.stakeholder, undefined, undefined, undefined, true)}
                </td>
                <td className = "multi-img-cell px-26 align-center">
                    {VCIcon(this.props.userSession?.user?.profile_access?.active_sh_vmh_access.find((item) => {return item.VMH_ID == this.props.vehicle.VMH_ID})?.vmh, undefined, undefined, undefined, true)}
                </td>
                <td className="multi-img-cell align-center">
                    {this.props.vehicle.tier && (
                        <Stars star={this.props.vehicle.tier} type={"Vehicle"} ID={this.props.vehicle.V_ID} key={this.props.vehicle.V_ID} mutable={""} confirmable/>
                    )}
                </td>
                <td className = "single-img-cell">
                    {
                        'utilization' in this.props.vehicle ? 
                            <span>{parseInt(this.props.vehicle.utilization * 100)}%</span>
                        :
                            <img src = "images/png-icons/dash-grey.png"/> 
                    }
                </td>
                <td className = "single-img-cell">
                    {
                        'utilization' in this.props.vehicle ? 
                            <span>{new Intl.NumberFormat('en-CA').format(this.props.vehicle.Odometer)} KM</span>
                        :
                            <img src = "images/png-icons/dash-grey.png"/> 
                    }
                </td>
                <td className = "single-img-cell">
                    {
                        'utilization' in this.props.vehicle ? 
                            <span>{this.props.vehicle.utilization?.total_bookings || this.props.vehicle.totalBookings}</span>
                        :
                            <img src = "images/png-icons/dash-grey.png"/> 
                    }
                </td>
                <td className = "single-img-cell">
                    {
                        'last_booking' in this.props.vehicle && this.props.vehicle.last_booking?.End_Date ?
                            moment(this.props.vehicle.last_booking.End_Date, "YYYY-MM-DD").format("MMM DD, YYYY")
                            :
                            this.props.vehicle.latestBooking?.scheduledReturnedAt ? 
                                moment(this.props?.vehicle?.latestBooking?.scheduledReturnedAt).format('MMM DD, YYYY')
                                : <img src = "images/png-icons/dash-grey.png"/> 
                    }
                </td>
                <td className = "action-cell">
                    <div className = "list-action-wrapper">
                        <a onClick={this.toggleActionDropdown}>
                            {Ellipsis()}
                        </a>

                        {this.state.action_dropdown && (
                            <div className = "list-action-dropdown">
                                <ul>
                                    <li onClick={() => this.editVehicle(this.props.vehicle)}>
                                        <span className = "float-left mr-8">{EditDefault()}</span><span className = "float-left">Edit</span>
                                        <div className = "clearfix"></div>
                                    </li>
                                    {this.props.vehicle.status === 'active' && (
                                        <>
                                            <li onClick={() => this.addReminder(this.props.vehicle.V_ID)}>
                                                <span className = "float-left mr-8">{VehicleReminderAdd()}</span><span className = "float-left">Add Reminder</span>
                                                <div className = "clearfix"></div>
                                            </li>
                                            <li onClick={() => this.retireVehicle(this.props.vehicle.V_ID)}>
                                                <span className = "float-left mr-8">{VehicleRetire()}</span><span className = "float-left">Retire</span>
                                                <div className = "clearfix"></div>
                                            </li>
                                        </>
                                    )}
                                </ul>
                            </div>
                        )}
                    </div>
                </td>
            </tr>
        );
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    data: store.data
})

export default connect(mapStateToProps)(VehiclesListRow)